import React from 'react';
import classNameBind from 'classnames/bind';
import Button from '../Button';
import styles from './Arrows.module.css';

const bindClasses = classNameBind.bind(styles);

const Arrows = ({
  leftArrowDisabled,
  rightArrowDisabled,
  leftArrowOnClick,
  rightArrowOnClick,
  dataId,
}) => (
  <div className={bindClasses('wrapper')} data-ppuc-id={dataId}>
    <div>
      <div className={bindClasses('right')}>
        <Button
          onClick={rightArrowOnClick}
          disabled={rightArrowDisabled}
          icon="arrow-right"
          dataId={`${dataId}.right`}
        />
      </div>
      <div className={bindClasses('left')}>
        <Button
          onClick={leftArrowOnClick}
          disabled={leftArrowDisabled}
          icon="arrow-left"
          dataId={`${dataId}.left`}
        />
      </div>
    </div>
  </div>
);

Arrows.defaultProps = {
  leftArrowDisabled: false,
  rightArrowDisabled: false,
  leftArrowOnClick: () => {},
  rightArrowOnClick: () => {},
  dataId: 'Arrows',
};

export { Arrows };
